import { render } from "./DonateModule.vue?vue&type=template&id=48b6bea2&scoped=true"
import script from "./DonateModule.vue?vue&type=script&lang=js"
export * from "./DonateModule.vue?vue&type=script&lang=js"

import "./DonateModule.vue?vue&type=style&index=0&id=48b6bea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b6bea2"]])

export default __exports__